
const selectAll = 'Select all that apply';
const yes = 'Yes';
const no = 'No';
const howMuch = 'Amount:';
const howMuchSaved = 'Saved:';
const accessType = 'Access:';
const whenYouNeed = 'When:';
const amountToBorrow = 'How much will you need to achieve your goal?';
const amountSaved = 'How much have you saved for your goal?';
const loanTiming = 'How soon will you need the money?';
const loanTimingOptions = {
  now: 'Now',
  less: 'Less than 1 Year',
  three: '3 months',
  six: '6 months',
  twelve: '1 year',
  more: 'Over 1 Year',
};
const loanAccess =
  'If you want to borrow, how do you want to access your money?';
const loanAccessOptions = {
  upFront: 'Up front',
  overTime: 'Over time',
  no: 'I do not want to borrow',
};
const accountBalances =
  'Knowing your balances will help us determine the best path to your financial confidence.';
const otherBalancesTooltip =
  'This information helps us recommend banking solutions.';

export default {
  /**
   * ============================
   * CONSUMER SPECIFIC GENERAL MESSAGES
   * ============================
   */
  'title.productTypePreference': "Today's goal?",
  'title.bankHabitsDeposit': 'Checking deposits',
  'title.accountFeatures': 'Checking features',
  'title.accountBalances': 'Deposit balances',
  'title.loanBalances': 'Loan balances',
  'title.goals': 'Financial goals',
  'title.homeOwner': 'Home ownership',
  'title.homeValue': 'Home value & loans',
  'title.mortgageValue': 'Total balances owed',
  'title.useHomeEquity': 'Equity',
  'title.healthcarePlan': 'High-deductible health plan',
  'title.retirementPlan': 'Retirement',
  'title.wantInsurance': 'Insurance',
  'title.demographics': 'Tell Me About Yourself',

  /**
   * ============================
   * COMMON CONSUMER QUESTIONS
   * ============================
   */

  productTypePreference: 'What would you like to do today?',
  'productTypePreference.subtext': selectAll,
  'productTypePreference.checking': 'Open a checking account (Manage my money)',
  'productTypePreference.savings': 'Save my money',
  'productTypePreference.lending': 'Borrow',
  'productTypePreference.retirement':
    'Protect my money (Retirement and Insurance)',

  reasonForVisit:
    'How did you hear about us?',
  'reasonForVisit.subtext': selectAll,
  'reasonForVisit.relation': 'Referred by friend or relative',
  'reasonForVisit.customer': 'Current customer',
  'reasonForVisit.signage': 'Branch signage',
  'reasonForVisit.associate': 'Referred by a business associate',
  'reasonForVisit.employee': 'Referred by a First Commonwealth employee',
  'reasonForVisit.advertisement': 'Advertisement',
  'reasonForVisit.internet': 'Internet',
  'reasonForVisit.newspaper': 'Newspaper',
  'reasonForVisit.radio': 'Radio',
  'reasonForVisit.other': 'Other',

  currentAccounts: 'Let’s talk about the type of accounts you have with us.',
  'currentAccounts.subtext': selectAll,
  'currentAccounts.general': 'Personal checking, savings, CDs or IRAs',
  'currentAccounts.loans': 'Personal loan or line',
  'currentAccounts.homeequity': 'Home Equity loan or line',
  'currentAccounts.mortgage': 'Mortgage loan',
  'currentAccounts.creditcard': 'Personal credit card',
  'currentAccounts.businessgeneral': 'Business checking, savings, or CDs',
  'currentAccounts.businessloan': 'Business loan or line',
  'currentAccounts.businesscreditcard': 'Business credit card',
  'currentAccounts.brokerage': 'Brokerage/Investments',
  'currentAccounts.insurance': 'Insurance',
  'currentAccounts.other': 'Other',

  existingPersonalBank: 'Currently, what bank do you use the most?',
  'existingPersonalBank.firstCommonwealth': 'First Commonwealth Bank',
  'existingPersonalBank.1stSummit': '1st Summit',
  'existingPersonalBank.allyBank': 'Ally Bank',
  'existingPersonalBank.altoonaFirst': 'Altoona First',
  'existingPersonalBank.ameriServ': 'AmeriServ',
  'existingPersonalBank.bbt': 'BB&T',
  'existingPersonalBank.central': 'Central Bank',
  'existingPersonalBank.chase': 'Chase',
  'existingPersonalBank.chime': 'Chime',
  'existingPersonalBank.cashapp': 'Cash App',
  'existingPersonalBank.cincinnatiFederal': 'Cincinnati Federal',
  'existingPersonalBank.citizens': 'Citizens Bank',
  'existingPersonalBank.cnb': 'CNB',
  'existingPersonalBank.dollar': 'Dollar Bank',
  'existingPersonalBank.ephrataNational': 'Ephrata National Bank',
  'existingPersonalBank.fifthThird': 'Fifth Third',
  'existingPersonalBank.firstFinancial': 'First Financial',
  'existingPersonalBank.firstMerchants': 'First Merchants',
  'existingPersonalBank.fnb': 'FNB',
  'existingPersonalBank.fulton': 'Fulton Bank',
  'existingPersonalBank.guardinSavings': 'Guardian Savings',
  'existingPersonalBank.heartland': 'Heartland Bank',
  'existingPersonalBank.huntingtonNB': 'Huntington NB',
  'existingPersonalBank.jerseyShoreState': 'Jersey Shore State Bank',
  'existingPersonalBank.key': 'KeyBank',
  'existingPersonalBank.kish': 'Kish Bank',
  'existingPersonalBank.mt': 'M&T Bank',
  'existingPersonalBank.membersFirstFederalCU': 'Members 1st Federal Credit Union',
  'existingPersonalBank.midpenn': 'Mid Penn Bank',
  'existingPersonalBank.mbt': 'Muncy Bank & Trust',
  'existingPersonalBank.northSidebt': 'North Side B&T',
  'existingPersonalBank.northwest': 'Northwest Bank',
  'existingPersonalBank.orrstown': 'Orrstown Bank',
  'existingPersonalBank.pennStateFederalCU': 'Penn State Federal Credit Union',
  'existingPersonalBank.pnc': 'PNC',
  'existingPersonalBank.psecu': 'PSECU',
  'existingPersonalBank.st': 'S&T Bank',
  'existingPersonalBank.somerset': 'Somerset Trust',
  'existingPersonalBank.td': 'TD Bank',
  'existingPersonalBank.truist': 'Truist',
  'existingPersonalBank.usb': 'US Bank',
  'existingPersonalBank.wesBanco': 'WesBanco',
  'existingPersonalBank.woodlands': 'Woodlands Bank',
  'existingPersonalBank.other': 'Other',
  'existingPersonalBank.noOther': 'No Other Bank',

  averageMonthlyCheckingDeposits:
    'How much do you deposit into your checking account in an average month?',
  'averageMonthlyCheckingDeposits.subtext': 'Higher monthly deposits may qualify you for a monthly service charge waiver on certain accounts.',

  overdraftConcern: 'Would you prefer an account that helps you spend only the money you have and provides the guarantee of no overdraft fees?',
  'overdraftConcern.subtext': 'We have an eco-friendly account that does not permit paper checks, which helps you to only spend the money you have. This also means no overdraft fees ever. It comes with a Mastercard® debit card made from ocean-bound plastic and lots of digital tools to pay bills, friends and more.',
  'overdraftConcern.true': 'Yes (This will recommend an account that does not permit paper checks.)',
  'overdraftConcern.false': 'No',

  'bankHabitsExpensesDayToDay': 'How do you pay for your day-to-day expenses?',
  'bankHabitsExpensesDayToDay.subtext': 'Select all that apply',
  'bankHabitsExpensesDayToDay.auto': 'Auto Debit (ACH withdrawal)',
  'bankHabitsExpensesDayToDay.debitCard': 'Debit Card',
  'bankHabitsExpensesDayToDay.creditCard': 'Credit Card',
  'bankHabitsExpensesDayToDay.online': 'Online Bill Pay',
  'bankHabitsExpensesDayToDay.cashOrCheck': 'Cash or Check',
  'bankHabitsExpensesDayToDay.mobile': 'Apple Pay<sup>TM</sup>, Google Pay<sup>TM</sup>, Samsung Pay<sup>TM</sup>, or Garmin Pay<sup>TM</sup>',
  'bankHabitsExpensesDayToDay.other': 'Other',

  accountFeatures:
    'All of our checking accounts come with services to enhance your banking experience. Let’s review these options and determine the best fit for your needs.',
  'accountFeatures.subtext': selectAll,
  'accountFeatures.all': 'Select all',
  'accountFeatures.online':
    'Online banking including alerts, eStatements, online financial management tool, Online Bill Payment, and Zelle<sup>&reg;</sup>',
  'accountFeatures.online.tooltip':
    'Our online banking lets you customize your dashboard, pay bills, set up transfers, receive eStatements and set up account alerts.  Use Money Manager, our personal financial management tool, as a one-stop location to view all of your accounts, set savings goals, establish a budget, and more.',
  'accountFeatures.mobile':
    'Mobile banking app including alerts, mobile deposit, eStatements, Online Bill Payment, and Zelle<sup>&reg;</sup>',
  'accountFeatures.mobile.tooltip':
    'Manage your money from your smartphone with everything that’s available in online banking, plus you can deposit checks with a picture and use Zelle<sup>&reg;</sup> to send money to, or receive money from, people you trust with a bank account in the US.',
  'accountFeatures.debit': 'Debit Card',
  'accountFeatures.debit.tooltip':
    'Bank and buy with security and confidence, including the ability to lock your debit card with SecurLOCK<sup>TM</sup></sup> EQUIP and tap & go<sup>&reg;</sup> at checkout with contactless technology.  Surcharge-free access to over 55,000 ATMs through Allpoint and Freedom Alliance.',
  'accountFeatures.directDeposit': 'Direct Deposit',
  'accountFeatures.directDeposit.tooltip':
    'Easily switch your Direct Deposit and other automatic deposits and payments to your new checking account using our ClickSWITCH tool.',
  'accountFeatures.wallet': 'Mobile Wallet',
  'accountFeatures.wallet.tooltip':
    'Add your debit card to Apple Pay<sup>TM</sup>, Google Pay<sup>TM</sup>, Samsung Pay<sup>TM</sup>, Fitbit Pay<sup>TM</sup>, or Garmin Pay<sup>TM</sup> for a faster checkout.  Card numbers are not stored on your device and are never shared with the merchant.',
  'accountFeatures.check': 'Checks',

  'noFCBDepositBalance.true': 'No FCB deposit balances',
  'noDepositBalanceOtherBank.true': 'No deposit balances at other banks',

  accountBalancesQuestionGroup: accountBalances,
  accountBalancesFCWQuestionGroup:
    'Let’s review your FCB deposit balances:',

  checkingBalance: 'Checking account(s)',
  'checkingBalance.-1': 'N/A',
  'checkingBalance.10': 'Less than $500',
  'checkingBalance.20': '$500 - $999',
  'checkingBalance.30': '$1,000 - $2,499',
  'checkingBalance.40': '$2,500 - $4,999',
  'checkingBalance.50': '$5,000 - $9,999',
  'checkingBalance.60': '$10,000 - $24,999',
  'checkingBalance.70': '$25,000 +',
  savingsBalance: 'Savings account(s)',
  'savingsBalance.-1': 'N/A',
  'savingsBalance.10': 'Less than $100',
  'savingsBalance.20': '$100 - $499',
  'savingsBalance.30': '$500 - $999',
  'savingsBalance.40': '$1,000 - $2,499',
  'savingsBalance.50': '$2,500 - $4,999',
  'savingsBalance.60': '$5,000 - $9,999',
  'savingsBalance.70': '$10,000 - $24,999',
  'savingsBalance.80': '$25,000 - $49,999',
  'savingsBalance.90': '$50,000 - $99,999',
  'savingsBalance.100': '$100,000 - $499,999',
  'savingsBalance.110': '$500,000 - $999,999',
  'savingsBalance.120': '$1,000,000 +',
  cdBalance: 'Certificate of Deposit(s)',
  'cdBalance.-1': 'N/A',
  'cdBalance.10': 'Less than $2,500',
  'cdBalance.20': '$2,500 - $9,999',
  'cdBalance.30': '$10,000 - $24,999',
  'cdBalance.40': '$25,000 - $49,999',
  'cdBalance.50': '$50,000 - $99,999',
  'cdBalance.60': '$100,000 - $499,999',
  'cdBalance.70': '$500,000 - $999,999',
  'cdBalance.80': '$1,000,000 +',
  retirementBalance: 'Retirement account(s) (IRA, 401K, etc.)',
  'retirementBalance.-1': 'N/A',
  'retirementBalance.10': 'Less than $2,500',
  'retirementBalance.20': '$2,500 - $9,999',
  'retirementBalance.30': '$10,000 - $24,999',
  'retirementBalance.40': '$25,000 - $49,999',
  'retirementBalance.50': '$50,000 - $99,999',
  'retirementBalance.60': '$100,000 - $499,999',
  'retirementBalance.70': '$500,000 - $999,999',
  'retirementBalance.80': '$1,000,000 +',

  accountBalancesOtherBankQuestionGroup:
    'What are your deposit balances at other banks?',

  'accountBalancesOtherBankQuestionGroup.tooltip': otherBalancesTooltip,

  checkingBalanceOtherBank: 'Checking account(s)',
  'details.checkingBalanceOtherBank': 'Other Bank Checking account(s)',
  'checkingBalanceOtherBank.-1': 'N/A',
  'checkingBalanceOtherBank.10': 'Less than $500',
  'checkingBalanceOtherBank.20': '$500 - $999',
  'checkingBalanceOtherBank.30': '$1,000 - $2,499',
  'checkingBalanceOtherBank.40': '$2,500 - $4,999',
  'checkingBalanceOtherBank.50': '$5,000 - $9,999',
  'checkingBalanceOtherBank.60': '$10,000 - $24,999',
  'checkingBalanceOtherBank.70': '$25,000 +',
  savingsBalanceOtherBank: 'Savings account(s)',
  'details.savingsBalanceOtherBank': 'Other Bank Savings account(s)',
  'savingsBalanceOtherBank.-1': 'N/A',
  'savingsBalanceOtherBank.10': 'Less than $100',
  'savingsBalanceOtherBank.20': '$100 - $499',
  'savingsBalanceOtherBank.30': '$500 - $999',
  'savingsBalanceOtherBank.40': '$1,000 - $2,499',
  'savingsBalanceOtherBank.50': '$2,500 - $4,999',
  'savingsBalanceOtherBank.60': '$5,000 - $9,999',
  'savingsBalanceOtherBank.70': '$10,000 - $24,999',
  'savingsBalanceOtherBank.80': '$25,000 - $49,999',
  'savingsBalanceOtherBank.90': '$50,000 - $99,999',
  'savingsBalanceOtherBank.100': '$100,000 - $499,999',
  'savingsBalanceOtherBank.110': '$500,000 - $999,999',
  'savingsBalanceOtherBank.120': '$1,000,000 +',
  cdBalanceOtherBank: 'Certificate of Deposit(s)',
  'details.cdBalanceOtherBank': 'Other Bank Certificate of Deposit(s)',
  'cdBalanceOtherBank.-1': 'N/A',
  'cdBalanceOtherBank.10': 'Less than $2,500',
  'cdBalanceOtherBank.20': '$2,500 - $9,999',
  'cdBalanceOtherBank.30': '$10,000 - $24,999',
  'cdBalanceOtherBank.40': '$25,000 - $49,999',
  'cdBalanceOtherBank.50': '$50,000 - $99,999',
  'cdBalanceOtherBank.60': '$100,000 - $499,999',
  'cdBalanceOtherBank.70': '$500,000 - $999,999',
  'cdBalanceOtherBank.80': '$1,000,000 +',
  retirementBalanceOtherBank: 'Retirement account(s) (IRA, 401K, etc.)',
  'details.retirementBalanceOtherBank': 'Other Bank Retirement account(s) (IRA, 401K, etc.)',
  'retirementBalanceOtherBank.-1': 'N/A',
  'retirementBalanceOtherBank.10': 'Less than $2,500',
  'retirementBalanceOtherBank.20': '$2,500 - $9,999',
  'retirementBalanceOtherBank.30': '$10,000 - $24,999',
  'retirementBalanceOtherBank.40': '$25,000 - $49,999',
  'retirementBalanceOtherBank.50': '$50,000 - $99,999',
  'retirementBalanceOtherBank.60': '$100,000 - $499,999',
  'retirementBalanceOtherBank.70': '$500,000 - $999,999',
  'retirementBalanceOtherBank.80': '$1,000,000 +',

  'noFCBLoanBalances.true': 'No FCB loan balances',
  'noLoanBalancesOtherBank.true': 'No loan balances at other banks',

  loanBalancesQuestionGroup: accountBalances,
  loanBalancesFCWQuestionGroup: 'Let’s review your FCB loan balances:',

  balanceLoansPersonal: 'Personal Loans and Lines',
  'balanceLoansPersonal.-1': 'N/A',
  'balanceLoansPersonal.10': 'Less than $5,000',
  'balanceLoansPersonal.20': '$5,000 - $9,999',
  'balanceLoansPersonal.30': '$10,000 - $19,999',
  'balanceLoansPersonal.40': '$20,000 - $24,999',
  'balanceLoansPersonal.50': '$25,000 - $34,999',
  'balanceLoansPersonal.60': '$35,000 +',
  balanceLoansHomeEquity: 'Home Equity Loans and Lines',
  'balanceLoansHomeEquity.-1': 'N/A',
  'balanceLoansHomeEquity.10': 'Less than $25,000',
  'balanceLoansHomeEquity.20': '$25,000 - $49,999',
  'balanceLoansHomeEquity.30': '$50,000 - $99,999',
  'balanceLoansHomeEquity.40': '$100,000 - $249,999',
  'balanceLoansHomeEquity.50': '$250,000 - $499,999',
  'balanceLoansHomeEquity.60': '$500,000 +',
  balanceMortgage: 'Mortgage Loans',
  'balanceMortgage.-1': 'N/A',
  'balanceMortgage.10': 'Less than $50,000',
  'balanceMortgage.20': '$50,000 - $99,999',
  'balanceMortgage.30': '$100,000 - $249,999',
  'balanceMortgage.40': '$250,000 - $499,999',
  'balanceMortgage.50': '$500,000 - $999,999',
  'balanceMortgage.60': '$1,000,000 +',
  balanceCredit: 'Credit Cards',
  'balanceCredit.-1': 'N/A',
  'balanceCredit.10': 'Less than $5,000',
  'balanceCredit.20': '$5,000 - $9,999',
  'balanceCredit.30': '$10,000 - $19,999',
  'balanceCredit.40': '$20,000 - $24,999',
  'balanceCredit.50': '$25,000 - $34,999',
  'balanceCredit.60': '$35,000 +',

  loanBalancesOtherBankQuestionGroup:
    'What are your loan balances at other banks?',
  'loanBalancesOtherBankQuestionGroup.tooltip': otherBalancesTooltip,

  balanceLoansPersonalOther: 'Personal Loans and Lines',
  'details.balanceLoansPersonalOther': 'Other Bank Personal Loans and Lines',
  'balanceLoansPersonalOther.-1': 'N/A',
  'balanceLoansPersonalOther.10': 'Less than $5,000',
  'balanceLoansPersonalOther.20': '$5,000 - $9,999',
  'balanceLoansPersonalOther.30': '$10,000 - $19,999',
  'balanceLoansPersonalOther.40': '$20,000 - $24,999',
  'balanceLoansPersonalOther.50': '$25,000 - $34,999',
  'balanceLoansPersonalOther.60': '$35,000 +',
  balanceLoansHomeEquityOther: 'Home Equity Loans and Lines',
  'details.balanceLoansHomeEquityOther': 'Other Bank Home Equity Loans and Lines',
  'balanceLoansHomeEquityOther.-1': 'N/A',
  'balanceLoansHomeEquityOther.10': 'Less than $25,000',
  'balanceLoansHomeEquityOther.20': '$25,000 - $49,999',
  'balanceLoansHomeEquityOther.30': '$50,000 - $99,999',
  'balanceLoansHomeEquityOther.40': '$100,000 - $249,999',
  'balanceLoansHomeEquityOther.50': '$250,000 - $499,999',
  'balanceLoansHomeEquityOther.60': '$500,000 +',
  balanceMortgageOther: 'Mortgage Loans',
  'details.balanceMortgageOther': 'Other Bank Mortgage Loans',
  'balanceMortgageOther.-1': 'N/A',
  'balanceMortgageOther.10': 'Less than $50,000',
  'balanceMortgageOther.20': '$50,000 - $99,999',
  'balanceMortgageOther.30': '$100,000 - $249,999',
  'balanceMortgageOther.40': '$250,000 - $499,999',
  'balanceMortgageOther.50': '$500,000 - $999,999',
  'balanceMortgageOther.60': '$1,000,000 +',
  balanceCreditOther: 'Credit Cards',
  'details.balanceCreditOther': 'Other Bank Credit Cards',
  'balanceCreditOther.-1': 'N/A',
  'balanceCreditOther.10': 'Less than $5,000',
  'balanceCreditOther.20': '$5,000 - $9,999',
  'balanceCreditOther.30': '$10,000 - $19,999',
  'balanceCreditOther.40': '$20,000 - $24,999',
  'balanceCreditOther.50': '$25,000 - $34,999',
  'balanceCreditOther.60': '$35,000 +',

  'creditCardPriorities': 'Which of these is important to you in a Credit Card?',
  'creditCardPriorities.cashback': 'Cash back rewards',
  'creditCardPriorities.rebuild': 'Rebuilding or establishing credit',

  savingGoalsQuestionGroup:
    "Understanding your <b>financial goals</b> is essential to helping you build a pathway to financial confidence. Let's start with your <b>savings</b> goals.",
  lendingGoalsQuestionGroup: "Now, let's explore any goals that could be supported through <b>borrowing</b>.",
  goalTypes: 'Your Goals:',
  'goalTypes.cardBuilder.save': 'Save',
  'goalTypes.emergencyGoal': 'Saving for an Emergency',
  'goalTypes.emergencyGoal.title': 'Saving for an Emergency',
  'goalTypes.emergencyGoal.iconClass': 'fa fa-exclamation-triangle',
  'emergencyGoal.cardBuilder.title': '<i class="fa fa-exclamation-triangle"></i><div>Saving for an Emergency</div>',
  emergencyGoalAmount: amountToBorrow,
  'emergencyGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.emergencyGoalAmount': `Goals: Saving for an emergency | ${amountToBorrow}`,
  emergencyGoalAmountSaved: amountSaved,
  'emergencyGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.emergencyGoalAmountSaved': `Goals: Saving for an emergency | ${amountSaved}`,
  'goalTypes.futureGoal': 'Future/Unexpected Expense',
  'goalTypes.futureGoal.title': 'Future/Unexpected Expense',
  'goalTypes.futureGoal.iconClass': 'fa fa-clock-o',
  'futureGoal.cardBuilder.title': '<i class="fa fa-clock-o"></i><div>Future/Unexpected Expense</div>',
  futureGoalAmount: amountToBorrow,
  'futureGoalAmount.cardBuilder.answerLabel': howMuch,
  'futureGoalType': 'What are you saving for?',
  'futureGoalType.subtext': 'CDs are a great way to earn interest on the money you don’t need right away. Select “Future” if you are interested in having a CD included as a solution to help you reach your financial goals.',
  'futureGoalType.future': 'Future',
  'futureGoalType.unexpected': 'Unexpected Expense',
  'details.futureGoalAmount': `Goals: Future/Unexpected Expense | ${amountToBorrow}`,
  futureGoalAmountSaved: amountSaved,
  'futureGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.futureGoalAmountSaved': `Goals: Future/Unexpected Expense | ${amountSaved}`,
  'goalTypes.childGoal': 'Child/Grandchild',
  'goalTypes.childGoal.title': 'Child/Grandchild',
  'goalTypes.childGoal.iconClass': 'fa fa-child',
  'childGoal.cardBuilder.title': '<i class="fa fa-child"></i><div>Child/Grandchild</div>',
  childGoalIsEducation: 'Are you saving for education expenses?',
  'childGoalIsEducation.yes': 'Yes',
  'childGoalIsEducation.no': 'No',
  childGoalAmount: amountToBorrow,
  'childGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.childGoalAmount': `Goals: Child/Grandchild | ${amountToBorrow}`,
  childGoalAmountSaved: amountSaved,
  'childGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.childGoalAmountSaved': `Goals: Child/Grandchild | ${amountSaved}`,
  childGoalTiming: loanTiming,
  'childGoalTiming.1': loanTimingOptions.less,
  'childGoalTiming.3': loanTimingOptions.three,
  'childGoalTiming.6': loanTimingOptions.six,
  'childGoalTiming.12': loanTimingOptions.twelve,
  'childGoalTiming.13': loanTimingOptions.more,
  'childGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.childGoalTiming': `Goals: Child/Grandchild | ${loanTiming}`,
  'goalTypes.vacationGoal': 'Vacation',
  'goalTypes.vacationGoal.title': 'Vacation',
  'goalTypes.vacationGoal.iconClass': 'fa fa-plane',
  'vacationGoal.cardBuilder.title': '<i class="fa fa-plane"></i><div>Vacation</div>',
  vacationGoalAmount: amountToBorrow,
  'vacationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.vacationGoalAmount': `Goals: Vacation | ${amountToBorrow}`,
  vacationGoalAmountSaved: amountSaved,
  'vacationGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.vacationGoalAmountSaved': `Goals: Vacation | ${amountSaved}`,
  vacationGoalTiming: loanTiming,
  'vacationGoalTiming.1': loanTimingOptions.now,
  'vacationGoalTiming.3': loanTimingOptions.three,
  'vacationGoalTiming.6': loanTimingOptions.six,
  'vacationGoalTiming.12': loanTimingOptions.twelve,
  'vacationGoalTiming.13': loanTimingOptions.more,
  'vacationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.vacationGoalTiming': `Goals: Vacation | ${loanTiming}`,
  vacationGoalAccess: loanAccess,
  'vacationGoalAccess.cardBuilder.answerLabel': accessType,
  'vacationGoalAccess.upFront': loanAccessOptions.upFront,
  'vacationGoalAccess.overTime': loanAccessOptions.overTime,
  'vacationGoalAccess.no': loanAccessOptions.no,
  'details.vacationGoalAccess': `Goals: Vacation | ${loanAccess}`,
  'goalTypes.holidayGoal': 'Holiday Purchases',
  'goalTypes.holidayGoal.title': 'Holiday Purchases',
  'goalTypes.holidayGoal.iconClass': 'fa fa-gift',
  'holidayGoal.cardBuilder.title': '<i class="fa fa-gift"></i><div>Holiday Purchases</div>',
  holidayGoalAmount: amountToBorrow,
  'holidayGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.holidayGoalAmount': `Goals: Holiday | ${amountToBorrow}`,
  holidayGoalAmountSaved: amountSaved,
  'holidayGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.holidayGoalAmountSaved': `Goals: Holiday | ${amountSaved}`,
  holidayGoalTiming: loanTiming,
  'holidayGoalTiming.1': loanTimingOptions.now,
  'holidayGoalTiming.3': loanTimingOptions.three,
  'holidayGoalTiming.6': loanTimingOptions.six,
  'holidayGoalTiming.12': loanTimingOptions.twelve,
  'holidayGoalTiming.13': loanTimingOptions.more,
  'holidayGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.holidayGoalTiming': `Goals: Holiday | ${loanTiming}`,
  holidayGoalAccess: loanAccess,
  'holidayGoalAccess.cardBuilder.answerLabel': accessType,
  'holidayGoalAccess.upFront': loanAccessOptions.upFront,
  'holidayGoalAccess.overTime': loanAccessOptions.overTime,
  'holidayGoalAccess.no': loanAccessOptions.no,
  'details.holidayGoalAccess': `Goals: Holiday | ${loanAccess}`,
  'goalTypes.educationGoal': 'Education',
  'goalTypes.educationGoal.title': 'Education',
  'goalTypes.educationGoal.iconClass': 'fa fa-graduation-cap',
  'educationGoal.cardBuilder.title': '<i class="fa fa-graduation-cap"></i><div>Education</div>',
  educationGoalAmount: amountToBorrow,
  'educationGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.educationGoalAmount': `Goals: Education | ${amountToBorrow}`,
  educationGoalAmountSaved: amountSaved,
  'educationGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.educationGoalAmountSaved': `Goals: Education | ${amountSaved}`,
  educationGoalTiming: loanTiming,
  'educationGoalTiming.1': loanTimingOptions.less,
  'educationGoalTiming.3': loanTimingOptions.three,
  'educationGoalTiming.6': loanTimingOptions.six,
  'educationGoalTiming.12': loanTimingOptions.twelve,
  'educationGoalTiming.13': loanTimingOptions.more,
  'educationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.educationGoalTiming': `Goals: Education | ${loanTiming}`,
  educationGoalAccess: loanAccess,
  'educationGoalAccess.cardBuilder.answerLabel': accessType,
  'educationGoalAccess.upFront': loanAccessOptions.upFront,
  'educationGoalAccess.overTime': loanAccessOptions.overTime,
  'educationGoalAccess.no': loanAccessOptions.no,
  'details.educationGoalAccess': `Goals: Education | ${loanAccess}`,
  'goalTypes.healthcareGoal': 'Healthcare',
  'goalTypes.healthcareGoal.title': 'Healthcare',
  'goalTypes.healthcareGoal.iconClass': 'fa fa-hospital-o',
  'healthcareGoal.cardBuilder.title': '<i class="fa fa-hospital-o"></i><div>Healthcare</div>',
  healthcareGoalAmount: amountToBorrow,
  'healthcareGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.healthcareGoalAmount': `Goals: Healthcare | ${amountToBorrow}`,
  healthcareGoalAmountSaved: amountSaved,
  'healthcareGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.healthcareGoalAmountSaved': `Goals: Healthcare | ${amountSaved}`,
  'healthcareGoalTiming': loanTiming,
  'healthcareGoalTiming.1': loanTimingOptions.now,
  'healthcareGoalTiming.3': loanTimingOptions.three,
  'healthcareGoalTiming.6': loanTimingOptions.six,
  'healthcareGoalTiming.12': loanTimingOptions.twelve,
  'healthcareGoalTiming.13': loanTimingOptions.more,
  'healthcareGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.healthcareGoalTiming': `Goals: Healthcare | ${loanTiming}`,
  healthcareGoalAccess: loanAccess,
  'healthcareGoalAccess.cardBuilder.answerLabel': accessType,
  'healthcareGoalAccess.upFront': loanAccessOptions.upFront,
  'healthcareGoalAccess.overTime': loanAccessOptions.overTime,
  'healthcareGoalAccess.no': loanAccessOptions.no,
  'healthcareGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.healthcareGoalTiming': `Goals: Healthcare | ${loanTiming}`,
  healthcareGoalDeductible: 'Do you participate in a high-deductible health plan?',
  'healthcareGoalDeductible.no': 'No',
  'healthcareGoalDeductible.yes': 'Yes',
  'healthcareGoalDeductible.no.tooltip': 'A high-deductible health plan (HDHP) offered by employers is a health plan with a higher deductible than a traditional insurance plan. The monthly premium is usually lower, but you pay more healthcare costs yourself (your deductible) before the insurance company starts to pay its share.  Your employer would have notified you during your benefits election if you have an HDHP.',
  'details.healthcareGoalAccess': `Goals: Healthcare | ${loanAccess}`,
  'goalTypes.majorPurchaseGoal': 'Major Purchase / Holiday / Vacation',
  'goalTypes.majorPurchaseGoal.title': 'Major Purchase / Holiday / Vacation',
  'goalTypes.majorPurchaseGoal.iconClass': 'fa fa-usd',
  'majorPurchaseGoal.cardBuilder.title': '<i class="fa fa-usd"></i><div>Major Purchase / Holiday / Vacation</div>',
  majorPurchaseGoalType: 'What type of purchase are you saving for?',
  'majorPurchaseGoalType.vacation': 'Vacation',
  'majorPurchaseGoalType.holiday': 'Holiday shopping',
  'majorPurchaseGoalType.other': 'Other purchase or life event',
  majorPurchaseGoalAmount: amountToBorrow,
  'majorPurchaseGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.majorPurchaseGoalAmount': `Goals: Major Purchase / Holiday / Vacation | ${amountToBorrow}`,
  majorPurchaseGoalAmountSaved: amountSaved,
  'majorPurchaseGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.majorPurchaseGoalAmountSaved': `Goals: Major Purchase / Holiday / Vacation | ${amountSaved}`,
  majorPurchaseGoalTiming: loanTiming,
  'majorPurchaseGoalTiming.1': loanTimingOptions.less,
  'majorPurchaseGoalTiming.3': loanTimingOptions.three,
  'majorPurchaseGoalTiming.6': loanTimingOptions.six,
  'majorPurchaseGoalTiming.12': loanTimingOptions.twelve,
  'majorPurchaseGoalTiming.13': loanTimingOptions.more,
  'majorPurchaseGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.majorPurchaseGoalTiming': `Goals: Major Purchase / Holiday / Vacation | ${loanTiming}`,
  majorPurchaseGoalAccess: loanAccess,
  'majorPurchaseGoalAccess.cardBuilder.answerLabel': accessType,
  'majorPurchaseGoalAccess.upFront': loanAccessOptions.upFront,
  'majorPurchaseGoalAccess.overTime': loanAccessOptions.overTime,
  'majorPurchaseGoalAccess.no': loanAccessOptions.no,
  'details.majorPurchaseGoalAccess': `Goals: Major Purchase / Holiday / Vacation | ${loanAccess}`,
  'goalTypes.lifeEventGoal': 'Major Purchase/Life Event',
  'goalTypes.lifeEventGoal.title': 'Major Purchase/Life Event',
  'goalTypes.lifeEventGoal.iconClass': 'fa fa-university',
  'lifeEventGoal.cardBuilder.title': '<i class="fa fa-university"></i><div>Major Purchase/Life Event</div>',
  lifeEventGoalAmount: amountToBorrow,
  'lifeEventGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.lifeEventGoalAmount': `Goals: Major Purchase/Life Event | ${amountToBorrow}`,
  lifeEventGoalAmountSaved: amountSaved,
  'lifeEventGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.lifeEventGoalAmountSaved': `Goals: Major Purchase/Life Event | ${amountSaved}`,
  lifeEventGoalTiming: loanTiming,
  'lifeEventGoalTiming.1': loanTimingOptions.less,
  'lifeEventGoalTiming.3': loanTimingOptions.three,
  'lifeEventGoalTiming.6': loanTimingOptions.six,
  'lifeEventGoalTiming.12': loanTimingOptions.twelve,
  'lifeEventGoalTiming.13': loanTimingOptions.more,
  'details.lifeEventGoalTiming': `Goals: Major Purchase/Life Event | ${loanTiming}`,
  lifeEventGoalAccess: loanAccess,
  'lifeEventGoalAccess.cardBuilder.answerLabel': accessType,
  'lifeEventGoalAccess.upFront': loanAccessOptions.upFront,
  'lifeEventGoalAccess.overTime': loanAccessOptions.overTime,
  'lifeEventGoalAccess.no': loanAccessOptions.no,
  'details.lifeEventGoalAccess': `Goals: Major Purchase/Life Event | ${loanAccess}`,
  'goalTypes.debtConsolidationGoal': 'Consolidate Debt',
  'goalTypes.debtConsolidationGoal.title': 'Consolidate Debt',
  'goalTypes.debtConsolidationGoal.iconClass': 'fa fa-credit-card',
  'debtConsolidationGoal.cardBuilder.title': '<i class="fa fa-credit-card"></i><div>Consolidate Debt</div>',
  debtConsolidationGoalAmount: amountToBorrow,
  'debtConsolidationGoalAmount.cardBuilder.answerLabel': howMuch,
  'debtConsolidationGoalAccess.upFront': loanAccessOptions.upFront,
  'debtConsolidationGoalAccess.overTime': loanAccessOptions.overTime,
  'details.debtConsolidationGoalAmount': `Goals: Consolidate Debt | ${amountToBorrow}`,
  'goalTypes.establishRebuildCreditGoal': 'Establish/Rebuild Credit',
  'goalTypes.establishRebuildCreditGoal.title': 'Establish/Rebuild Credit',
  'goalTypes.establishRebuildCreditGoal.iconClass': 'fa fa-credit-card',
  'establishRebuildCreditGoal.cardBuilder.subtitle': 'Selecting this goal will recommend tools and resources to help you understand and monitor your credit score; and establish or rebuild your credit.',
  'goalTypes.homeGoal': 'Buy/Refinance a Home',
  'goalTypes.homeGoal.title': 'Buy/Refinance a Home',
  'goalTypes.homeGoal.iconClass': 'fa fa-home',
  'homeGoal.cardBuilder.title': '<i class="fa fa-home"></i><div>Buy/Refinance a Home</div>',
  homeGoalPurpose: 'Do you want to buy a home or refinance?',
  'homeGoalPurpose.buy': 'Buy',
  'homeGoalPurpose.refinance': 'Refinance',
  homeGoalAmount: amountToBorrow,
  'homeGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.homeGoalAmount': `Goals: Buy/Refinance a Home | ${amountToBorrow}`,
  homeGoalAmountSaved: amountSaved,
  'homeGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.homeGoalAmountSaved': `Goals: Buy/Refinance a Home | ${amountSaved}`,
  homeGoalTiming: loanTiming,
  'homeGoalTiming.1': loanTimingOptions.less,
  'homeGoalTiming.3': loanTimingOptions.three,
  'homeGoalTiming.6': loanTimingOptions.six,
  'homeGoalTiming.12': loanTimingOptions.twelve,
  'homeGoalTiming.13': loanTimingOptions.more,
  'homeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.homeGoalTiming': `Goals: Buy/Refinance a Home | ${loanTiming}`,
  homeGoalAccess: loanAccess,
  'homeGoalAccess.cardBuilder.answerLabel': accessType,
  'homeGoalAccess.upFront': loanAccessOptions.upFront,
  'homeGoalAccess.overTime': loanAccessOptions.overTime,
  'homeGoalAccess.no': loanAccessOptions.no,
  'details.homeGoalAccess': `Goals: Buy/Refinance a Home | ${loanAccess}`,
  'goalTypes.homeImprovementGoal': 'Home Improvement',
  'goalTypes.homeImprovementGoal.title': 'Home Improvement',
  'goalTypes.homeImprovementGoal.iconClass': 'fa fa-home',
  'homeImprovementGoal.cardBuilder.title': '<i class="fa fa-home"></i><div>Home Improvement</div>',
  homeImprovementGoalAmount: amountToBorrow,
  'homeImprovementGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.homeImprovementGoalAmount': `Goals: Home Improvement | ${amountToBorrow}`,
  homeImprovementGoalAmountSaved: amountSaved,
  'homeImprovementGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.homeImprovementGoalAmountSaved': `Goals: Home Improvement | ${amountSaved}`,
  homeImprovementGoalTiming: loanTiming,
  'homeImprovementGoalTiming.1': loanTimingOptions.less,
  'homeImprovementGoalTiming.3': loanTimingOptions.three,
  'homeImprovementGoalTiming.6': loanTimingOptions.six,
  'homeImprovementGoalTiming.12': loanTimingOptions.twelve,
  'homeImprovementGoalTiming.13': loanTimingOptions.more,
  'homeImprovementGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.homeImprovementGoalTiming': `Goals: Home Improvement | ${loanTiming}`,
  homeImprovementGoalAccess: loanAccess,
  'homeImprovementGoalAccess.cardBuilder.answerLabel': accessType,
  'homeImprovementGoalAccess.upFront': loanAccessOptions.upFront,
  'homeImprovementGoalAccess.overTime': loanAccessOptions.overTime,
  'homeImprovementGoalAccess.no': loanAccessOptions.no,
  'details.homeImprovementGoalAccess': `Goals: Home Improvement | ${loanAccess}`,
  'goalTypes.refinanceHomeGoal': 'Refinance Home',
  'goalTypes.refinanceHomeGoal.title': 'Refinance Home',
  'goalTypes.refinanceHomeGoal.iconClass': 'fa fa-home',
  'refinanceHomeGoal.cardBuilder.title': '<i class="fa fa-home"></i><div>Refinance Home</div>',
  refinanceHomeGoalAmount: amountToBorrow,
  'refinanceHomeGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.refinanceHomeGoalAmount': `Goals: Refinance | ${amountToBorrow}`,
  refinanceHomeGoalAmountSaved: amountSaved,
  'refinanceHomeGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.refinanceHomeGoalAmountSaved': `Goals: Refinance | ${amountSaved}`,
  refinanceHomeGoalTiming: loanTiming,
  'refinanceHomeGoalTiming.1': loanTimingOptions.now,
  'refinanceHomeGoalTiming.3': loanTimingOptions.three,
  'refinanceHomeGoalTiming.6': loanTimingOptions.six,
  'refinanceHomeGoalTiming.12': loanTimingOptions.twelve,
  'refinanceHomeGoalTiming.13': loanTimingOptions.more,
  'refinanceHomeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.refinanceHomeGoalTiming': `Goals: Refinance | ${loanTiming}`,
  'goalTypes.vehicleGoal': 'Vehicle',
  'goalTypes.vehicleGoal.title': 'Vehicle',
  'goalTypes.vehicleGoal.iconClass': 'fa fa-car',
  'vehicleGoal.cardBuilder.title': '<i class="fa fa-car"></i><div>Vehicle</div>',
  vehicleGoalAmount: amountToBorrow,
  'vehicleGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.vehicleGoalAmount': `Goals: Vehicle | ${amountToBorrow}`,
  vehicleGoalAmountSaved: amountSaved,
  'vehicleGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.vehicleGoalAmountSaved': `Goals: Vehicle | ${amountSaved}`,
  'vehicleGoalTiming': loanTiming,
  'vehicleGoalTiming.1': loanTimingOptions.now,
  'vehicleGoalTiming.3': loanTimingOptions.three,
  'vehicleGoalTiming.6': loanTimingOptions.six,
  'vehicleGoalTiming.12': loanTimingOptions.twelve,
  'vehicleGoalTiming.13': loanTimingOptions.more,
  'vehicleGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.vehicleGoalTiming': `Goals: Vehicle | ${loanTiming}`,
  vehicleGoalAccess: loanAccess,
  'vehicleGoalAccess.cardBuilder.answerLabel': accessType,
  'vehicleGoalAccess.upFront': loanAccessOptions.upFront,
  'vehicleGoalAccess.overTime': loanAccessOptions.overTime,
  'vehicleGoalAccess.no': loanAccessOptions.no,
  'details.vehicleGoalAccess': `Goals: Vehicle | ${loanAccess}`,
  'goalTypes.retirementGoal': 'Retirement',
  'goalTypes.retirementGoal.title': 'Retirement',
  'goalTypes.retirementGoal.iconClass': 'fa fa-money',
  'retirementGoal.cardBuilder.title': '<i class="fa fa-money"></i><div>Retirement</div>',
  retirementGoalAmount: amountToBorrow,
  'retirementGoalAmount.tooltip': 'One rule of thumb - half your annual salary for early career, 3 times your salary for mid-career, and 6 times for late career.',
  'retirementGoalAmount.cardBuilder.answerLabel': howMuch,
  'details.retirementGoalAmount': `Goals: Retirement | ${amountToBorrow}`,
  retirementGoalAmountSaved: amountSaved,
  'retirementGoalAmountSaved.cardBuilder.answerLabel': howMuchSaved,
  'details.retirementGoalAmountSaved': `Goals: Retirement | ${amountSaved}`,
  'retirementGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.retirementGoalTiming': `Goals: Retirement | ${loanTiming}`,
  'goalTypes.insuranceGoal': 'Insurance',
  'goalTypes.insuranceGoal.title': 'Insurance',
  'goalTypes.insuranceGoal.iconClass': 'fa fa-times-circle-o',
  'insuranceGoal.cardBuilder.title': '<i class="fa fa-times-circle-o"></i><div>Insurance</div>',
  insuranceGoalTiming: loanTiming,
  'insuranceGoalTiming.1': loanTimingOptions.now,
  'insuranceGoalTiming.3': loanTimingOptions.three,
  'insuranceGoalTiming.6': loanTimingOptions.six,
  'insuranceGoalTiming.12': loanTimingOptions.twelve,
  'insuranceGoalTiming.13': loanTimingOptions.more,
  'insuranceGoalTiming.cardBuilder.answerLabel': whenYouNeed,
  'details.insuranceGoalTiming': `Goals: Insurance | ${loanTiming}`,
  'goalTypes.creditCardGoal': 'Credit Card',
  'goalTypes.creditCardGoal.title': 'Credit Card',
  'goalTypes.creditCardGoal.iconClass': 'fa fa-times-circle-o',
  'creditCardGoal.cardBuilder.title': '<i class="fa fa-times-circle-o"></i><div>Credit Card</div>',
  creditCardGoalType: 'Which is the most important to you?',
  'creditCardGoalType.rewards': 'Rewards',
  'creditCardGoalType.secured': 'Secured',

  homeOwner:
    'Using the equity in your home may be the most efficient way to borrow for you to reach your goal(s).  Do you own a home?',
  'homeOwner.true': 'Yes',
  'homeOwner.false': 'No',

  homeValue: 'What is the estimated value of your home?',
  homeMortgage:
    'Do you have any loans against your home?  This would include mortgages, home equity loans and home equity lines of credit.',
  'homeMortgage.true': 'Yes',
  'homeMortgage.false': 'No',
  mortgageBalance:
    'What is the outstanding balance of all loans and lines of credit against your home?',

  useHomeEquity:
    'You have built up enough equity in your home for your borrowing needs. Would you like to use your home to secure your loan?',
  'useHomeEquity.true': 'Yes',
  'useHomeEquity.false': 'No',

  healthcarePlan:
    'You indicated that you want to save for your healthcare, do you participate in a high-deductible health plan?',
  'healthcarePlan.tooltip':
    'A high-deductible health plan (HDHP) offered by employers is a health plan with a higher deductible than a traditional insurance plan. The monthly premium is usually lower, but you pay more healthcare costs yourself (your deductible) before the insurance company starts to pay its share.  Your employer would have notified you during your benefits election if you have an HDHP.',
  'healthcarePlan.true': 'Yes',
  'healthcarePlan.false': 'No',

  retirementPlan:
    'You mentioned that you have a goal of saving for retirement. Tell us where you are in your retirement journey:',
  'retirementPlan.subtext': selectAll,
  'retirementPlan.starting': 'Just starting out',
  'retirementPlan.assets': 'Have $25,000 or more in investable assets',
  'retirementPlan.rate':
    'Looking to get a higher rate of return on your retirement savings',
  'retirementPlan.retirement': 'Nearing retirement',

  wantInsurance:
    'Our insurance team can help protect you, your loved ones and your most valuable assets.  What type of insurance can we help you with?',
  'wantInsurance.subtext': selectAll,
  'wantInsurance.homeowners': 'Homeowners',
  'wantInsurance.auto': 'Auto',
  'wantInsurance.life': 'Life Insurance / Long-Term Care',

  demographicsQuestionGroup: "Let's learn a little more about you.",

  annualIncome: 'What is your annual household income?',
  'annualIncome.tooltip': 'This information helps us to recommend banking solutions for you including savings and retirement options.',
  'annualIncome.125': 'Less than $25,000',
  'annualIncome.250': '$25,000 to $34,999',
  'annualIncome.350': '$35,000 to $49,999',
  'annualIncome.500': '$50,000 to $59,999',
  'annualIncome.600': '$60,000 to $74,999',
  'annualIncome.750': '$75,000 to $99,999',
  'annualIncome.1000': '$100,000 to $124,999',
  'annualIncome.1250': '$125,000 to $149,999',
  'annualIncome.1500': '$150,000 to $199,999',
  'annualIncome.2000': '$200,000 and up',

  postalCode: 'What is your zip code?',

  lifeStage: 'Which of the below best describes you now?',
  'lifeStage.early': 'Early-career',
  'lifeStage.mid': 'Mid-career',
  'lifeStage.late': 'Late-career',
  'lifeStage.retired': 'Already retired',
  'lifeStage.none': 'None of the above',

  activeMilitaryOrVeteran: 'Are you active military or a veteran?',
  'activeMilitaryOrVeteran.subtext': 'We would like to say thank you to the veterans and active service members in our communities with additional checking and mortgage benefits.',
  'activeMilitaryOrVeteran.true': 'Yes',
  'activeMilitaryOrVeteran.false': 'No',

  businessOwner: 'Do you own a business?',
  'businessOwner.true': 'Yes',
  'businessOwner.false': 'No',

  existingBusinessBank: 'Who do you consider your primary bank for your business?',
  'existingBusinessBank.firstCommonwealth': 'First Commonwealth Bank',
  'existingBusinessBank.1stSummit': '1st Summit',
  'existingBusinessBank.allyBank': 'Ally Bank',
  'existingBusinessBank.altoonaFirst': 'Altoona First',
  'existingBusinessBank.ameriServ': 'AmeriServ',
  'existingBusinessBank.bbt': 'BB&T',
  'existingBusinessBank.central': 'Central Bank',
  'existingBusinessBank.chase': 'Chase',
  'existingBusinessBank.chime': 'Chime',
  'existingBusinessBank.cincinnatiFederal': 'Cincinnati Federal',
  'existingBusinessBank.citizens': 'Citizens Bank',
  'existingBusinessBank.cnb': 'CNB',
  'existingBusinessBank.dollar': 'Dollar Bank',
  'existingBusinessBank.ephrataNational': 'Ephrata National Bank',
  'existingBusinessBank.fifthThird': 'Fifth Third',
  'existingBusinessBank.firstFinancial': 'First Financial',
  'existingBusinessBank.firstMerchants': 'First Merchants',
  'existingBusinessBank.fnb': 'FNB',
  'existingBusinessBank.fulton': 'Fulton Bank',
  'existingBusinessBank.guardinSavings': 'Guardian Savings',
  'existingBusinessBank.heartland': 'Heartland Bank',
  'existingBusinessBank.huntingtonNB': 'Huntington NB',
  'existingBusinessBank.jerseyShoreState': 'Jersey Shore State Bank',
  'existingBusinessBank.key': 'KeyBank',
  'existingBusinessBank.kish': 'Kish Bank',
  'existingBusinessBank.mt': 'M&T Bank',
  'existingBusinessBank.membersFirstFederalCU': 'Members 1st Federal Credit Union',
  'existingBusinessBank.midpenn': 'Mid Penn Bank',
  'existingBusinessBank.mbt': 'Muncy Bank & Trust',
  'existingBusinessBank.northSidebt': 'North Side B&T',
  'existingBusinessBank.northwest': 'Northwest Bank',
  'existingBusinessBank.orrstown': 'Orrstown Bank',
  'existingBusinessBank.pennStateFederalCU': 'Penn State Federal Credit Union',
  'existingBusinessBank.pnc': 'PNC',
  'existingBusinessBank.psecu': 'PSECU',
  'existingBusinessBank.st': 'S&T Bank',
  'existingBusinessBank.somerset': 'Somerset Trust',
  'existingBusinessBank.td': 'TD Bank',
  'existingBusinessBank.truist': 'Truist',
  'existingBusinessBank.usb': 'US Bank',
  'existingBusinessBank.wesBanco': 'WesBanco',
  'existingBusinessBank.woodlands': 'Woodlands Bank',
  'existingBusinessBank.other': 'Other',
  'existingBusinessBank.noOther': 'No Other Bank',

  existingBusinessProducts: 'What products do you currently use for your business?',
  'existingBusinessProducts.tooltip': selectAll,
  'existingBusinessProducts.checking': 'Checking',
  'existingBusinessProducts.savings-mm': 'Savings/Money Market',
  'existingBusinessProducts.loans': 'Loans',
  'existingBusinessProducts.other': 'Other',
};